import React, {useEffect, useState} from 'react';
import './TypePrintSadanShop.scss'
import numericFunction from "../../../utils/NumericFunction";
import {formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";

const NoteBookReportPrintTwo = (props) => {

  const format = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  const [componentData, setComponentData] = useState({})
  useEffect(() => {
    const temp = {...props.data.data.data.data}
    setComponentData(temp)
  }, [props.data])

  try {
    return (
      <div className="main-print-factor">

        <table className="solid-print-table">

          <thead>
          <tr className="empty-header-tr">
            <th className="empty-header-th" colSpan={7}></th>
          </tr>
          <tr>
            <th colSpan={7}>
              <div className="box-top-side-review-accounts" style={{border: 'none'}}>

                <div className="shop-name">
                  <div className="name-side">
                    <h3>{componentData?.shopName}</h3>
                  </div>
                </div>

                <div className="list-detail">
                  <div className="inline-text">
                    <p>از تاریخ :</p>
                    <p>{numericFunction.e2p(componentData?.startDate)}</p>
                  </div>

                  <div className="inline-text">
                    <p>از سند :</p>
                    <p>{numericFunction.e2p(componentData?.firstId)}</p>
                  </div>

                  <div className="inline-text">
                    <p>تـاریـخ :</p>
                    <p>{new Date().toLocaleDateString("fa-ir", format)}</p>
                  </div>

                  <div className="inline-text">
                    <p>تا تاریخ :</p>
                    <p>{numericFunction.e2p(componentData?.endDate)}</p>
                  </div>

                  <div className="inline-text">
                    <p>تا سند :</p>
                    <p>{numericFunction.e2p(componentData?.lastId)}</p>
                  </div>

                  <div className="inline-text" style={{columnGap: '4px'}}>
                    {/*<p>شماره صفحه :</p>*/}
                    {/*<p>{numericFunction.e2p(index + 1)}</p>*/}
                    {/*<p>از</p>*/}
                    {/*<p>{numericFunction.e2p(makeData.length)}</p>*/}
                  </div>
                </div>
              </div>
            </th>
          </tr>

          <tr className="note-book-head">
            <th></th>
            <th>کد</th>
            <th>عنوان</th>
            <th>گردش بدهکار</th>
            <th>گردش بستانکار</th>
            <th>مانده بدهکار</th>
            <th>مانده بستانکار</th>
          </tr>
          </thead>

          <tbody>
          {componentData.data.length > 0 && componentData.data.map((z) => {

              const level = z.level
              const accountCode = z.accountCode
              const accountName = z.accountName
              const bed = z.bed
              const bes = z.bes
              const bedRemaining = z.bedRemaining
              const besRemaining = z.besRemaining
              const hasSubData = z.hasSubData

              return <>
                <tr>
                  <th style={{borderBottom: '1px solid white'}}><p className="note-book-table-p">
                    {level === '0' ? "گروه" : level === '1' ? "کل" : level === '2' ? "معین" : level === '3' ? "تفصیل" : ""}
                  </p></th>
                  <th>{numericFunction.e2p(accountCode)}</th>
                  <th>{numericFunction.e2p(accountName)}</th>
                  <th>{formatToPersianAddCommaNegativeToParentheses(bed)}</th>
                  <th>{formatToPersianAddCommaNegativeToParentheses(bes)}</th>
                  <th>{formatToPersianAddCommaNegativeToParentheses(bedRemaining)}</th>
                  <th>{formatToPersianAddCommaNegativeToParentheses(besRemaining)}</th>
                </tr>

                {hasSubData && z.subData.map((o) => {

                    const level = o.level
                    const accountCode = o.accountCode
                    const accountName = o.accountName
                    const bed = o.bed
                    const bes = o.bes
                    const bedRemaining = o.bedRemaining
                    const besRemaining = o.besRemaining
                    const hasSubData = o.hasSubData

                    return <>
                      <tr>
                        <th style={{borderBottom: '1px solid white'}}><p style={{paddingRight: '10px'}}
                                                                         className="note-book-table-p">
                          {level === '0' ? "گروه" : level === '1' ? "کل" : level === '2' ? "معین" : level === '3' ? "تفصیل" : ""}
                        </p></th>
                        <th>{numericFunction.e2p(accountCode)}</th>
                        <th>{numericFunction.e2p(accountName)}</th>
                        <th>{formatToPersianAddCommaNegativeToParentheses(bed)}</th>
                        <th>{formatToPersianAddCommaNegativeToParentheses(bes)}</th>
                        <th>{formatToPersianAddCommaNegativeToParentheses(bedRemaining)}</th>
                        <th>{formatToPersianAddCommaNegativeToParentheses(besRemaining)}</th>
                      </tr>

                      {hasSubData && o.subData.map((t) => {

                          const level = t.level
                          const accountCode = t.accountCode
                          const accountName = t.accountName
                          const bed = t.bed
                          const bes = t.bes
                          const bedRemaining = t.bedRemaining
                          const besRemaining = t.besRemaining
                          const hasSubData = t.hasSubData

                          return <>
                            <tr>
                              <th style={{borderBottom: '1px solid white'}}><p style={{paddingRight: '20px'}}
                                                                               className="note-book-table-p">
                                {level === '0' ? "گروه" : level === '1' ? "کل" : level === '2' ? "معین" : level === '3' ? "تفصیل" : ""}
                              </p></th>
                              <th>{numericFunction.e2p(accountCode)}</th>
                              <th>{numericFunction.e2p(accountName)}</th>
                              <th>{formatToPersianAddCommaNegativeToParentheses(bed)}</th>
                              <th>{formatToPersianAddCommaNegativeToParentheses(bes)}</th>
                              <th>{formatToPersianAddCommaNegativeToParentheses(bedRemaining)}</th>
                              <th>{formatToPersianAddCommaNegativeToParentheses(besRemaining)}</th>
                            </tr>

                            {hasSubData && t.subData.map((r) => {

                              const level = r.level
                              const accountCode = r.accountCode
                              const accountName = r.accountName
                              const bed = r.bed
                              const bes = r.bes
                              const bedRemaining = r.bedRemaining
                              const besRemaining = r.besRemaining

                              return <>
                                <tr>
                                  <th style={{borderBottom: '1px solid white'}}><p style={{paddingRight: '30px'}}
                                                                                   className="note-book-table-p">
                                    {level === '0' ? "گروه" : level === '1' ? "کل" : level === '2' ? "معین" : level === '3' ? "تفصیل" : ""}
                                  </p>
                                  </th>
                                  <th>{numericFunction.e2p(accountCode)}</th>
                                  <th>{numericFunction.e2p(accountName)}</th>
                                  <th>{formatToPersianAddCommaNegativeToParentheses(bed)}</th>
                                  <th>{formatToPersianAddCommaNegativeToParentheses(bes)}</th>
                                  <th>{formatToPersianAddCommaNegativeToParentheses(bedRemaining)}</th>
                                  <th>{formatToPersianAddCommaNegativeToParentheses(besRemaining)}</th>
                                </tr>
                              </>
                            })}
                          </>
                        }
                      )}
                    </>
                  }
                )}
              </>
            }
          )}
          </tbody>

          <tfoot className="empty-header-footer">
          <tr>
            <th colSpan={7}></th>
          </tr>
          </tfoot>
        </table>

      </div>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};
export default NoteBookReportPrintTwo;